import "./SessionPageLogo.css";
import React from "react";

export default ({ baseAddress, label }) => (
    <a className="session-page-logo" href={baseAddress}>
        {label || "Link to Gradifi homepage"}
    </a>
);